import React, { useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import "./index.css";
import parse from "html-react-parser";


export default function Banner({ webpageData, carouselRef }) {
    const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
    const ticketData = webpageData?.ticketSection || {};
    
    // Check if current time is after July 8, 2025 5PM ET
    const isAfterRegistrationDeadline = () => {
        const now = new Date();
        const deadline = new Date('2025-07-08T17:00:00-04:00'); // July 8, 2025 5PM ET
        // const deadline = new Date('2025-07-08T00:35:00-07:00');
        return now >= deadline;
    };
    
    const showFlashOffer = !isAfterRegistrationDeadline();
    
    const handleLearnMoreClick = () => {
        const nextSection = document.getElementById("next-section"); // Replace with your actual section ID
        if (nextSection) {
          nextSection.scrollIntoView({ behavior: "smooth" });
        }
      };

    const bannerData = webpageData?.banner || {}

    return (
        <div className="bannerBackgroundPost">
            <Container fluid className="ps-0 pe-0">
                <div className="position-relative z-3">

                {showFlashOffer && (
                    <Image
                      src={imgCDNURL + "banner_sticker.webp"}
                      className="flash-offer-sticker"
                      alt="Independence Day Flash Offer"
                      loading="lazy"
                      onClick={() => {
                        const isMobile = window.innerWidth <= 767;
                      
                        if (isMobile && carouselRef.current) {
                          const index = ticketData.tickets.findIndex(
                            (ticket) => ticket.title === "General Admission"
                          );
                          if (index >= 0) {
                            carouselRef.current.goToSlide(index);
                            // Scroll to ticket section after carousel moves
                            setTimeout(() => {
                              const element = document.getElementById("general-admission-card");
                              if (element) {
                                const yOffset = -90;
                                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                window.scrollTo({ top: y, behavior: "smooth" });
                              }
                            }, 300);
                          }
                        } else {
                          const element = document.getElementById("general-admission-card");
                          if (element) {
                            const yOffset = -90;
                            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                            window.scrollTo({ top: y, behavior: "smooth" });
                          }
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    />
                )}

                    <Container className="backgroundHeadingContainer">
                        <Row className="banner-content-home">
                            <Col md={8} lg={7} className="banner-text-container">
                                
                                 <Image src={imgCDNURL + "ussaicbanner.webp"} className="bannerlogoimage" loading="lazy" alt="US Strategy Logo" />
                                <div className="banner-info">
                                    <div className="info-item">
                                        <Image src={imgCDNURL + "locationicon.webp"} className="locationicon" loading="lazy" alt="Location icon" />
                                        {bannerData.eventDetails.eventAddressLink ? (
                                            <a href={parse(bannerData.eventDetails.eventAddressLink)} target="_blank" rel="noopener noreferrer" className="address-link">
                                                <span>
                                                    {parse(bannerData.eventDetails.eventVenue)}<br />
                                                    {parse(bannerData.eventDetails.eventAddress)}
                                                </span>
                                            </a>
                                        ) : (
                                            <span>
                                                {parse(bannerData.eventDetails.eventVenue)}<br />
                                                {parse(bannerData.eventDetails.eventAddress)}
                                            </span>
                                        )}
                                    </div>
                                    <div className="info-item">
                                        <Image src={imgCDNURL + "calendericon.webp"} className="calendericon" loading="lazy" alt="Calendar icon" />
                                            <span>
                                                {parse(bannerData.eventDetails.eventDate)}<br />
                                                {parse(bannerData.eventDetails.eventTime)}
                                            </span>
                                    </div>


                                    
                                </div>

                                <div className="mobile-learn">
                                        <p className="learn-more-text">LEARN MORE</p>
                                        <Image src={imgCDNURL + "accordionicon.webp"} onClick={handleLearnMoreClick}
  style={{ cursor: "pointer" }} className="accordion-icon" loading="lazy" alt="accordion icon" />
                                            
                                    </div>
                            </Col>
                        </Row>
                    </Container>
                    
                </div>
            </Container>
        </div>
    );
}